import { useCallback, useEffect, useState } from 'react';
import {
  CHAT_MODEL_CHANGE_EVENT,
  isValidChatModel,
  normalizeChatModel,
  readChatModel,
  writeChatModel,
  dispatchChatModelChange,
} from '../utils/chatModelStorage';

export function useChatModel() {
  const [chatModel, setChatModelState] = useState(readChatModel);

  useEffect(() => {
    const syncFromStorage = () => {
      setChatModelState(readChatModel());
    };
    const onCustomChange = event => {
      const next = event?.detail?.model;
      if (next && isValidChatModel(next)) {
        setChatModelState(next);
        return;
      }
      syncFromStorage();
    };

    window.addEventListener('storage', syncFromStorage);
    window.addEventListener(CHAT_MODEL_CHANGE_EVENT, onCustomChange);
    return () => {
      window.removeEventListener('storage', syncFromStorage);
      window.removeEventListener(CHAT_MODEL_CHANGE_EVENT, onCustomChange);
    };
  }, []);

  const setChatModel = useCallback(nextModel => {
    if (!isValidChatModel(nextModel)) return;
    const normalized = writeChatModel(nextModel);
    setChatModelState(normalized);
    dispatchChatModelChange(normalized);
  }, []);

  return {
    chatModel: normalizeChatModel(chatModel),
    setChatModel,
  };
}
